export default "__VITE_ASSET__BX$bs_28__"